module.exports = __webpack_public_path__ + "static/gtm_2-3156cb84fe8bcc425875a6a8142b1bbe.png";